module.exports = __webpack_public_path__ + "img/27.6b9c38dc.jpg";